import ReactJson from 'react-json-view-with-toggle';
import CommonPaperWrapper from '../../../components/CommonPaperWrapper';
import { SectionWrapper } from '../../../components/tableComponents';
import CustomizedAccordion from '../../../components/AccordionComponent';
import { isValidBase64, unzipBase64 } from '../utils/base64Utils';
import CopyTxtIconBtn from '../../../components/CopyTxtIconBtn';


function JsonView(data: any){
  return (<>
      <CommonPaperWrapper 
          children={
              <ReactJson 
                  collapseStringsAfterLength={55}  
                  collapsed={false}
                  theme={'twilight'}  
                  data-testid="json" 
                  src={data}
              />
          }
      />
  </>);
}

const parse = (data:string) => {
  let parsedData: Record<string, any> | Uint8Array | undefined;
  try {
    let unzippedData: Uint8Array | string = data
    
    if(isValidBase64(unzippedData)) unzippedData = unzipBase64(data);
    
    if(unzippedData instanceof Uint8Array ) return parsedData = unzippedData;
    
    parsedData = JSON.parse(unzippedData);

  } catch(e){
      console.error(e);        
  }
  return parsedData;
}

type props = {
  data: string
}

const TxMessageData = ({data}: props) => {
    const parsedData = parse(data);
  
  let dataDisplay: JSX.Element  =  <p>No data to show</p> ;

  if((parsedData instanceof Uint8Array )){
    dataDisplay = (<div style={{width:"100%", overflow:"hidden", fontSize: "0.8rem", wordWrap:"break-word", display:"inline-block"}}>{parsedData.toString()}</div>)
  }
  if(!(parsedData instanceof Uint8Array || !parsedData)){
    dataDisplay = (
      <>
        <CopyTxtIconBtn value={parsedData? JSON.stringify(parsedData): ""}  />
        {JsonView(parsedData)}
      </>
    )
  }

  return (
    <SectionWrapper>
        <CustomizedAccordion summary='Data'  >
            {dataDisplay}
        </CustomizedAccordion>  
    </SectionWrapper>
  )
}

export default TxMessageData;
